export default "__VITE_ASSET__79ab8beb__"